module.exports = __webpack_public_path__ + "img/level_06_gold.f5ec140d.svg";